import React from 'react';
import { Box, Chip, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useReviewCounts } from '../review/useReviewCounts';
import {
  REVIEW_CATEGORY_LABELS,
  REVIEW_QUEUE_CATEGORIES,
} from '../review/types';
import {
  dashboardInteractiveCardSx,
  dashboardSectionTitleSx,
} from './dashboardMuiStyles';

const cardSx = {
  ...dashboardInteractiveCardSx,
  p: { xs: 2, xxl: 2.25, xxxl: 2.5 },
  cursor: 'pointer',
};

export const ReviewBacklogSection = () => {
  const { counts, loading } = useReviewCounts();

  const body = (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Typography variant="h6" component="h2" sx={dashboardSectionTitleSx}>
          Review backlog
        </Typography>
        {!loading && counts.all > 0 && (
          <Chip size="small" color="primary" label={`${counts.all} due`} />
        )}
      </Box>

      {loading && (
        <Typography variant="body1" color="text.secondary">
          Loading review counts…
        </Typography>
      )}

      {!loading && counts.all === 0 && (
        <Typography variant="body1" color="text.secondary">
          All caught up — nothing due for review.
        </Typography>
      )}

      {!loading && counts.all > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {REVIEW_QUEUE_CATEGORIES.map((category) => {
            const due = counts[category];
            if (due <= 0) {
              return null;
            }
            return (
              <Chip
                key={category}
                variant="outlined"
                label={`${REVIEW_CATEGORY_LABELS[category]} (${due})`}
              />
            );
          })}
        </Box>
      )}
    </>
  );

  if (loading) {
    return (
      <Paper variant="outlined" sx={cardSx}>
        {body}
      </Paper>
    );
  }

  return (
    <RouterLink
      to="/review"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <Paper variant="outlined" sx={cardSx}>
        {body}
      </Paper>
    </RouterLink>
  );
};

export default ReviewBacklogSection;
